import { NodegroupsDetailPanel } from "@/components/nodegroups/panels/Detail";
import { NodegroupsNodePanel } from "@/components/nodegroups/panels/Node";
import { NodegroupAuditPanel } from "@/components/instance/panels/Audit";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { useResourceContext } from "@/layouts/ResourceContext";
import {
  DeleteOutlined,
  DownOutlined,
  PlayCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, Space } from "antd";
import { useTranslation } from "react-i18next";
import { useUpdate, useInvalidate } from "@refinedev/core";
import { RESOURCE_TYPE_NODEGROUPS } from "./nodegroups";
import { RefreshButton } from "@/components/common/RefreshButton";
import { useResourceDelete } from "@/hooks/useResourceDelete";
import { MonitoringPanel } from "@/components/instance/panels/Monitoring";

const RESOURCE = RESOURCE_TYPE_NODEGROUPS;

export const NodegroupsDetailTabs = [
  { key: "details", label: "Detail", children: <NodegroupsDetailPanel /> },
  { key: "audit", label: "Audit", children: <NodegroupAuditPanel /> },
  { key: 'monitoring', label: 'Monitoring', children: <MonitoringPanel mode={"nodegroup"}/> },
];

export const NodegroupsActions = () => {
  const { t } = useTranslation();
  const { state, dispatch } = useResourceContext();
  const navigate = useResourceNavigate();
  const [selectedInstance] = state.selectedResources;
  const invalidate = useInvalidate();

  const navigateToCreation = () => {
    navigate(
      { resource: RESOURCE, action: "create" },
      { state: { key: "nodegroup", resource: RESOURCE } },
    );
  };
  const { mutateAsync: deleteMutate } = useResourceDelete();
  const { mutate, isLoading: isUpdating } = useUpdate({
    successNotification: (response, { id, values }, resource) => {
      const { action, data } = values;
      return {
        message: t(`nodegroups.actionResult.${action}.success`, { id }),
        description: "Success",
        type: "success",
      };
    },
  });

  const lifecycleMenu = [
    {
      key: "start",
      label: (
        <span>
          <PlayCircleOutlined /> Start
        </span>
      ),
      disabled: !selectedInstance,
    },
    {
      key: "stop",
      label: (
        <span>
          <StopOutlined /> Stop
        </span>
      ),
      disabled: !selectedInstance,
    },
    {
      key: "delete",
      label: (
        <span>
          <DeleteOutlined /> Delete
        </span>
      ),
      disabled: !selectedInstance || !(selectedInstance.type === "shared"),
    },
  ];
  const actionsMenu = [
    { key: "details", label: t("nodegroups.menu.details") },
    {
      key: "changeNodegroup",
      label: "Change Node Group",
      disabled: !selectedInstance,
    },
    {
      key: "changeAutoScaled",
      label: "Change Auto Scaled",
      disabled: !selectedInstance,
    },

    //    { key: 'settings', label: t('nodegroups.menu.settings'), children: [
    //      { key: 'changeNodegroup', label: 'Change Node Group', disabled: !selectedInstance || !(selectedInstance.type === "shared" && selectedInstance.autoscaled === "false")},
    //      { key: 'changeHadoop', label: 'Change Hadoop' },
    //      { key: 'changeMySQL', label: 'Change MySQL' },
    //      { key: 'changeCapacity', label: 'Change Capacity' },
    //      { key: 'changeAutoScaled', label: 'Change Auto Scaled' },
    //    ] },
  ];

  const onClickLifecycle = (item) => {
    const [selectedNodegroup] = state.selectedResources;
    console.log("Lifecycle:", selectedNodegroup.id, item.key);
    if (item.key === "delete") {
      deleteMutate({
        resource: RESOURCE,
        id: selectedInstance.id,
      });
    } else {
      mutate({
        resource: "nodegroups",
        id: selectedInstance.id,
        values: {
          action: item.key,
        },
      });
    }
  };
  const onClickAction = (item) => {
    const [selectedInstance] = state.selectedResources;
    console.log("Action:", selectedInstance.id, item.key);
    navigate({
      resource: RESOURCE,
      action: item.key,
      key: selectedInstance.id,
    });
  };

  const buttons = [
    <Dropdown
      key="state"
      menu={{ items: lifecycleMenu, onClick: onClickLifecycle }}
      placement="bottom"
      arrow
    >
      <Button>
        <Space>
          {t("nodegroups.menu.state", "Nodegroups State")}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>,
    <Dropdown
      key="actions"
      menu={{ items: actionsMenu, onClick: onClickAction }}
      placement="bottom"
      arrow
    >
      <Button>
        <Space>
          {t("nodegroups.menu.actions", "Actions")}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>,
    <Button key="launch" onClick={navigateToCreation}>
      {t("nodegroups.menu.launch")}
    </Button>,
    <RefreshButton
      onClick={() => {
        invalidate({
          resource: RESOURCE,
          invalidates: ["list"],
        });
      }}
    />,
  ];
  return <Space>{buttons}</Space>;
};
